<template>
    <div class="content-header-left col-md-9 col-12 mb-2">
        <div class="row breadcrumbs-top">
            <div class="col-12 d-flex ">
            <h2 class="content-header-title float-start mb-0">Knowledge Center</h2>
            <!-- <div class="breadcrumb-wrapper">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a :href="`/knowledge/center`">
                            KnCenter
                        </a>
                    </li>
                </ol>
            </div> -->
            </div>
        </div>
    </div>
    <KnowledgeBaseSearch :url="`/knowledge/category/search`" :method="showResults" :pagination="false"/>
    <section id="knowledge-base-content" ref="resultDev">
        <div class="row kb-search-content-info match-height" style="position:relative;min-height:300px;min-width:100%;">
            <!-- sales card -->
            <div class="col-md-3 col-sm-6 col-12 kb-search-content" v-for="(categoryList, index) in categoryLists"
                :key="index" style="position:relative" v-if="categoryLists.length > 0">
                <div class="card">
                    <!-- <a :href="'center/'+categoryList.slug + '/all/videos'" v-if="userStore.user.isDIY == false">

                        <img :src="categoryList.image_url" class="card-img-top" :alt="categoryList.title"
                            v-if="categoryList.image_url" />
                        <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/7/635655bc62bc7-dynamically-retrieve-seo-data-from-your-model.jpg"
                            class="card-img-top" :alt="categoryList.title" v-else />
                        <div class="card-body text-center">
                            <h4 class="text-primary">{{ categoryList.title }}</h4>
                            <p class="text-body mt-1 mb-0">
                                {{ categoryList.description }}
                            </p>

                        </div>

                    </a> -->

                    <router-link :to="{ name: 'knowledge-center-videos', params: { slug: categoryList.slug } }">
                        <img :src="categoryList.image_url" class="card-img-top" :alt="categoryList.title" v-if="categoryList.image_url" />
                        <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/7/635655bc62bc7-dynamically-retrieve-seo-data-from-your-model.jpg"
                            class="card-img-top" :alt="categoryList.title" v-else />
                        <div class="card-body text-center">
                            <h4 class="text-primary">{{ categoryList.title }}</h4>
                        </div>
                    </router-link>
                    <hr  v-if="can=='can_edit'"/>
                    <!-- dropdown -->
                    <div class="editDeleteSection"  v-if="can=='can_edit'">
                        <div class="allEditDelete d-flex align-items-center">
                            <div class="mr-1" v-on:click="actionTrigger(1, categoryList.uuid);">
                                <b-link class="mr-50">
                                    <vue-feather type="edit-3"></vue-feather>
                                </b-link>
                            </div>
                            <div class="mr-1" @click="actionTrigger(0, categoryList.uuid)" v-if="categoryList.deleted_at == null">
                                <div class="d-flex align-items-center">
                                    <b-link class="mr-50">
                                        <vue-feather type="trash-2"></vue-feather>
                                    </b-link>
                                </div>
                            </div>
                        </div>
                        <div class="dropdown b-dropdown show btn-group" id="__BVID__935">
                        </div>
                    </div>

                </div>
            </div>
            <!-- end -->
            <div class="col-12 text-center no-result " v-else>
                <h4 class="mt-4"> result not found!!</h4>
            </div>
            <CreditFixrrLoader styleType="dynamic" :toggle="ContentisLoading"/>
            <b-col cols="12">
                <!-- pagination -->
                <div v-if="containPagination == true">
                    <div class="my-2 d-flex justify-content-center" v-if="categoryLists.length">
                        <pagination v-model="currentPage" :records="rows" :per-page="perPage" @paginate="getList"/>
                    </div>
                </div>
            </b-col>
        </div>
        <!-- sweet alert -->
        <div id="sweetAlertDelete" class="swal2-container swal2-center swal2-backdrop-show" style="overflow-y: auto;"
            v-if="showSweetDialog &&  can=='can_edit'">
            <div aria-labelledby="swal2-title" aria-describedby="swal2-html-container"
                class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog"
                aria-live="assertive" aria-modal="true" style="display: grid;">
                <button type="button" class="swal2-close" style="display: none;"
                    aria-label="Close this dialog">×</button>
                <ul class="swal2-progress-steps" style="display: none;"></ul>
                <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
                    <div class="swal2-icon-content">!</div>
                </div>
                <img class="swal2-image" style="display: none;">
                <h2 class="swal2-title" id="swal2-title" style="display: block;">
                    Are you sure ?
                </h2>
                <div class="swal2-html-container" style="display: block;" v-if="actionType == 0">
                    You won't be able to revert this!
                </div>
                <input class="swal2-input" style="display: none;">
                <input type="file" class="swal2-file" style="display: none;">
                <div class="swal2-range" style="display: none;">
                    <input type="range">
                    <output></output>
                </div>
                <select class="swal2-select" style="display: none;"></select>
                <div class="swal2-radio" style="display: none;"></div>
                <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
                    <input type="checkbox">
                    <span class="swal2-label"></span>
                </label>
                <textarea class="swal2-textarea" style="display: none;"></textarea>
                <div class="swal2-validation-message" id="swal2-validation-message" style="display: none;"></div>
                <div class="swal2-actions">
                    <div class="swal2-loader"></div>
                    <button type="button" class="swal2-confirm btn btn-primary" style="display: inline-block;"
                        aria-label="" v-on:click="openCategoryEditor" v-if="actionType == 1">Yes, Edit it!</button>
                    <button type="button" class="swal2-confirm btn btn-primary" style="display: inline-block;"
                        aria-label="" v-on:click="deleteCategory" v-else>Yes, delete it!</button>
                    <button type="button" class="swal2-deny mr-10" style="display: none;"
                        aria-label="">No</button>&nbsp;&nbsp;&nbsp;
                    <button id="closeDeleter" type="button" class="swal2-cancel btn btn-outline-danger ms-1"
                        style="display: inline-block;" aria-label="sweetAlertDelete"
                        v-on:click="closeSweetBox">Cancel</button>
                </div>
                <div class="swal2-footer" style="display: none;"></div>
                <div class="swal2-timer-progress-bar-container">
                    <div class="swal2-timer-progress-bar" style="display: none;"></div>
                </div>
            </div>
        </div>
        <a type="button" href="#" class="btn btn-outline-secondary d-none d-sm-block waves-effect" data-toggle="modal"
            data-target="#editCategoryData" ref="clicker" hidden style="display:none  !important" v-if="can=='can_edit'">clickers</a>
        <!-- <EditCategoryKnowledgeBase :uuid="categoryId" :method="getList" :category="toEditData"/> -->
        <div  v-if="can=='can_edit'">
            <div class="modal fade" id="editCategoryData" tabindex="-1" aria-labelledby="editCategoryDataTitle"
                style="display: none;" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg two-factor-auth-sms">
                    <div class="modal-content" style="position:relative">
                        <div class="modal-header bg-transparent">
                            <button id="editCategoryDataClose" type="button" class="btn-close" data-dismiss="modal"
                                aria-label="Close"><span aria-hidden="true" ref="closeEdit">×</span></button>
                        </div>
                        <div class="modal-body pb-5 px-sm-5 mx-50">
                            <form action="javascript:;" class="mt-2" v-on:submit.prevent="editCategory">
                                <div class="row">
                                    <div class="col-md-12 col-12">
                                        <div class="form-group mb-2">
                                            <label for="blog-edit-title">Category Title</label>
                                            <b-form-input id="blog-edit-title" v-model="categoryTitle"
                                                placeholder="Category Title" />
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group mb-2">
                                            <label>Category Description</label>
                                            <div id="blog-editor-wrapper">
                                                <b-form-textarea id="textarea-state" v-model="categoryDecription"
                                                    placeholder="Enter at least 10 characters" rows="3">
                                                </b-form-textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mb-2">
                                        <div class="border rounded p-2">
                                            <h4 class="mb-1">Featured Image</h4>
                                            <div class="media flex-column flex-md-row">
                                                <img :src="file" id="blog-feature-image preview"
                                                    class="rounded mr-2 mb-1 mb-md-0" width="170" height="110"
                                                    alt="Blog Featured Image" v-if="file" />
                                                <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview"
                                                    class="rounded mr-2 mb-1 mb-md-0" width="170" height="110"
                                                    alt="Blog Featured Image" v-else />

                                                <div class="media-body">
                                                    <small class="text-muted">Required image resolution 800x400, image
                                                        size 10mb.</small>
                                                    <p class="my-50">
                                                        <a href="javascript:void(0);"
                                                            id="blog-image-text">C:\fakepath\banner.jpg</a>
                                                    </p>
                                                    <div class="d-inline-block">
                                                        <div class="form-group mb-0">
                                                            <div class="custom-file">
                                                                <input type="file" class="custom-file-input"
                                                                    id="blogCustomFile" accept="image/*"
                                                                    data-toggle="modal" data-target="#larger"
                                                                    @change="selectedImg"
                                                                    enctype="multipart/form-data" />
                                                                <label class="custom-file-label"
                                                                    for="blogCustomFile">Choose file</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-50 d-flex justify-content-end">
                                        <button type="submit" class="btn btn-primary mr-1">Publish Category</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <CreditFixrrLoader styleType="dynamic" :toggle="EditisLoading"/>
                    </div>

                </div>

            </div>
        </div>
        <div class="modal fade text-left show" id="larger" tabindex="-1" aria-labelledby="myModalLabel17"
            style="padding-right: 15px;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <cropper v-if='img' class="cropper" :src="img" :stencil-props="{
                            aspectRatio: 4 / 2
                        }" @change="change" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary waves-effect waves-float waves-light"
                            data-dismiss="modal">Accept</button>
                    </div>
                </div>
            </div>
        </div>

    </section>

    <CreditFixrrLoader styleType="full" :toggle="PageisLoading"/>
</template>
<script>
import { BLink, BFormInput, BFormTextarea, BRow, BCol } from "bootstrap-vue-3";
import { ref } from 'vue'
import KnowledgeBaseSearch from './KnowledgeBaseSearch.vue';
import EditCategoryKnowledgeBase from '../models/EditCategoryKnowledgeBase.vue';
import CreditFixrrLoader from '../loader/CreditFixrrLoader.vue'
import axios from "axios";
import vSelect from 'vue-select'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-select/dist/vue-select.css';
import 'vue-advanced-cropper/dist/style.css';
import { useUserStore } from '../../stores/UserStore.js'
export default {
    components: {
        KnowledgeBaseSearch, EditCategoryKnowledgeBase, vSelect, BFormInput, Cropper,CreditFixrrLoader,BRow, BCol
    },
    data(){
        return{
            categoryLists:{}
        }
    },
    setup() {
        const showSweetDialog = ref(false),
            categoryId = ref(null),
            clicker = ref(),
            actionType = ref(null),
            categoryTitle = ref(null),
            categoryDecription = ref(null),
            toEditData = ref({}),
            closeEdit = ref(),
            prevDataResult =ref({}),
            img = ref(null),
            file = ref(null),
            can = ref(null),
            display = ref(""),
            resultDev = ref(null),
            ContentisLoading = ref(true),
            EditisLoading = ref(false),
            PageisLoading = ref(false),
            currentPage = ref(1),
            perPage = ref(),
            prevPage = ref(),
            nextPage = ref(),
            rows = ref(),
            containPagination =ref(true);
        return {
            showSweetDialog,
            actionType,
            categoryId,
            clicker,
            closeEdit,
            categoryTitle,
            categoryDecription,
            toEditData,
            display,
            resultDev,
            prevDataResult,
            ContentisLoading,
            EditisLoading,
            PageisLoading,
            currentPage,
            containPagination,
            perPage,
            prevPage,
            nextPage,
            rows,
            can,
            img,
            file,
            userStore:useUserStore()
        }
    },
    created(){
        this.getList(1);
    },
    mounted() {
        this.getList(1);
    },
    methods: {
        showResults(result,pagination){
            if(result.data == undefined){
                this.getList()
                this.containPagination = true
            }else{
                if(result.data.data.length <= 0 ){
                    toastr.error('No Result Found','Search')
                    this.getList()
                    this.containPagination = true
                }else{
                    let $this = this;
                    let dataCurrent = result.data;
                    $this.categoryLists = dataCurrent.data
                    $this.prevDataResult = dataCurrent.data
                    $this.can = result.data.will_edit
                    $this.ContentisLoading =false;
                    $this.containPagination = pagination
                }
            }

        },
        async getList(page) {
            if(typeof page == null || typeof page == undefined){
                page = 1
            }
            let $this = this;
            let route = this.$router.resolve({
                name: 'knowledge-center'
            });
            await axios.post(`${route.href}?page=${+page}`).then(({ data }) => {
                let dataCurrent = data.data.data;
                $this.categoryLists = dataCurrent.data
                $this.prevDataResult = dataCurrent.data
                $this.can = data.data.will_edit
                $this.ContentisLoading =false;

                $this.currentPage = dataCurrent.current_page
                $this.perPage = dataCurrent.per_page
                $this.prevPage = dataCurrent.prev_page_url
                $this.nextPage = dataCurrent.next_page_url
                $this.rows = dataCurrent.total

            }).catch()
        },
        actionTrigger(type, id) {
            this.actionType = type;
            this.showSweetDialog = true;
            this.categoryId = id;
        },
        closeSweetBox() {
            this.actionType = null;
            this.showSweetDialog = false;
            this.categoryId = null;
        },
        openCategoryEditor() {
            this.showSweetDialog = false;
            this.PageisLoading = true;
            axios.post(`/admin/knowledge/${this.categoryId}`).then((data) => {
                if (data) {
                    this.categoryTitle = data.data.data.title
                    this.categoryDecription = data.data.data.description
                    this.file = data.data.data.image_url
                    this.toEditData = data.data.data
                    this.clicker.click();
                    this.PageisLoading = false;
                }
            })
        },
        deleteCategory() {
            this.categoryId
            this.PageisLoading = true;
            axios.post(`/admin/knowledge/${this.categoryId}/delete`).then(({ data }) => {
                this.getList();
                this.PageisLoading = false;
                this.closeSweetBox();
            }).catch()
        },
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
        converter(canvas) {
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
        },
        clearFields() {
            this.categoryTitle = null;
            this.categoryDecription = null;
            this.file = null;
        },
        editCategory() {
            if (this.uuid != "") {
                var catTitle = this.categoryTitle,
                    catdecription = this.categoryDecription,
                    file = this.file;
                if (this.file == this.toEditData.image_url) {
                    file = ""
                }
                const params = {
                    category_title: catTitle,
                    category_decription: catdecription,
                    image: file
                }
                if (catTitle != "" && catdecription != "") {
                    this.EditisLoading = true;
                    var $this = this;

                    axios.put(`/admin/knowledge/update/category/${this.categoryId}`, params).then(({ data }) => {
                        if (data.error == false) {
                            $this.EditisLoading = false;
                            $this.clearFields();
                            $this.getList()
                            setTimeout(() => {
                                $this.closeEdit.click();
                            }, 1000);
                            return toastr.success(data.message, "Success");
                        }
                    }).catch((error) => {
                        return toastr.error(error.message, "error!");
                    })
                } else {
                    toastr.error('All fields are required!', "error!");
                }

            }


        }
    },
};
</script>
<style>
.editDeleteSection {
    position: relative;
    height: 34px;
}

.allEditDelete {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0%, -50%);
}

#video-edit-input {
    background: white;
}

#video-edit-input input {
    height: 28px;
    background: white;
}
</style>
